module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="horizontal-guideline-inner"></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/editor/guideline/HorizontalGuidelineView.tpl
// module id = 2985
// module chunks = 0